export const getAreaCode = (cellphone: string): string | undefined => {
  let result: string | undefined = undefined
  if (!cellphone) {
    return result
  }
  const regex = /\((.+?)\)/g
  const options = cellphone.match(regex)
  if (options) {
    const option = options[options.length - 1]
    if (option) {
      result = option.substring(1, option.length - 1)
    }
  } else {
    const trimmed = cellphone.trim()
    const plusMatch = trimmed.match(/^\+\s*(\d+)/)
    if (plusMatch && plusMatch[1]) {
      result = `+${plusMatch[1]}`
    }
  }
  return result ? result : undefined
}

export const getPhone = (cellphone: string): string => {
  let result: string | undefined = ""
  if (!cellphone) {
    return result
  }
  const trimmed = cellphone.trim()
  // 若无括号且以 +数字 开头，则视为只有区号，没有电话号码
  const hasParentheses = /\(.*\)/.test(trimmed)
  if (!hasParentheses) {
    const plusMatch = trimmed.match(/^\+\s*(\d+)/)
    if (plusMatch && plusMatch[1]) {
      return ""
    }
  }
  result = trimmed.split(")").pop()
  return result ? result : ""
}
